<div class="report-page-root-container  cash-variance-exception-report-component-container  ">
  <div class="page-content">
    <div class="page-header">
      <img class="icon" src="assets/images/menu/svg/cash-variance-exception-report.svg">
      <div class="title">
        {{title}}
      </div>
      <div class="action-btn-container">
        @if(permission.can_export || permission.can_execute){
        <button mat-button color="accent" class="action-btn btn-export" (click)="exportClicked()"
          [disabled]="IsDownloading">
          <img class="download-icon" [src]="
              IsDownloading
                ? 'assets/images/animated/download/download-anim.svg'
                : 'assets/images/animated/download/download-no-anim.svg'
            " />
          <span class="action-btn-title">Export</span>
        </button>
        }
      </div>
    </div>
    <div class="page-details">
      <form class="edit-form" [formGroup]="editForm">
        <div class="detail-section">
          <div class="content-container">
            <div class="row">
              <mat-form-field class="week-selection">
                <mat-label>Week No</mat-label>
                <mat-select formControlName="week_no">
                  <mat-option *ngFor="let week of weeks" [value]="week.week_no">
                    {{ week.displayText }}
                  </mat-option>
                </mat-select>
              </mat-form-field>

              <mat-form-field class="shop-selection">
                <mat-label>Shop</mat-label>
                <input matInput formControlName="shop_id" [matAutocomplete]="shopAuto" (input)="filterShops()"
                  (focus)="filterShops()" autocomplete="off" placeholder="Select a shop">
                <button *ngIf="editForm.get('shop_id')?.value" matSuffix mat-icon-button aria-label="Clear"
                  (click)="clearShop()">
                  <mat-icon>close</mat-icon>
                </button>
                <mat-autocomplete #shopAuto="matAutocomplete" [displayWith]="displayShop">
                  <mat-option *ngFor="let shop of filteredShopList" [value]="shop"
                    [class.all-option]="shop.name === 'ALL'">
                    <span [style.font-weight]="shop.name === 'ALL' ? 'normal' : 'normal'">
                      {{ shop.name }}
                    </span>
                  </mat-option>
                </mat-autocomplete>
                <mat-error
                  *ngIf="editForm.get('shop_id')?.invalid && (editForm.get('shop_id')?.touched || editForm.get('shop_id')?.dirty)">
                  <ng-container
                    *ngIf="editForm.get('shop_id')?.hasError('invalidShop') || editForm.get('shop_id')?.hasError('required')">
                    Please select a valid shop.
                  </ng-container>
                </mat-error>
              </mat-form-field>

            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>